export enum CALLOUT_TONE {
  NEUTRAL = 'neutral',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
}
export enum CALLOUT_EMPHASIS {
  SUBTLE = 'subtle',
  STRONG = 'strong',
}
export enum CALLOUT_SIZE {
  COMPACT = 'compact',
  DEFAULT = 'default',
}
